const SOURCE_TAG = 'INDOEXCH_WEBVIEW';
const PARENT_SOURCE_TAG = 'INDOEXCH_WEBVIEW_PARENT';

// Channel name for webview_flutter JavascriptChannel.
// Flutter side must register: addJavaScriptChannel('IndoExchBridge', onMessageReceived: ...)
const FLUTTER_CHANNEL = 'IndoExchBridge';

function isEmbedded() {
  try {
    return (
      window.self !== window.top ||
      !!window.ReactNativeWebView ||
      !!window.flutter_inappwebview ||
      !!window[FLUTTER_CHANNEL]
    );
  } catch {
    return true;
  }
}

function postToApp(type, payload) {
  const message = JSON.stringify({
    source: SOURCE_TAG,
    type,
    payload: payload || {},
    timestamp: Date.now(),
  });

  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(message);
  } else if (window.flutter_inappwebview?.callHandler) {
    window.flutter_inappwebview.callHandler('onMessage', message);
  } else if (window[FLUTTER_CHANNEL]?.postMessage) {
    window[FLUTTER_CHANNEL].postMessage(message);
  } else if (window.parent !== window) {
    window.parent.postMessage(
      { source: SOURCE_TAG, type, payload: payload || {}, timestamp: Date.now() },
      '*'
    );
  } else {
    console.warn('[WebViewBridge] No handler found for message:', type);
  }
}

function sendBalanceUpdate(balance, exposure) {
  postToApp('BALANCE_UPDATE', { balance, exposure });
}

function sendBetPlaced(details) {
  postToApp('BET_PLACED', details);
}

function sendSessionExpired() {
  postToApp('SESSION_EXPIRED', {});
}

function sendLogout() {
  postToApp('LOGOUT', {});
}

export {
  SOURCE_TAG,
  PARENT_SOURCE_TAG,
  FLUTTER_CHANNEL,
  isEmbedded,
  postToApp,
  sendBalanceUpdate,
  sendBetPlaced,
  sendSessionExpired,
  sendLogout,
};
